import type { CapabilityMode } from "@/api/admin/delegation"

export type LibraryAdminPermissions = {
  /** Create, reconfigure (source credentials), delete, retry indexing: platform-only on the backend. */
  canManagePlatformOnly: boolean
  /** Tree backfill start/restart/cancel/status: the `indexing` capability. */
  canManageIndexing: boolean
}

/**
 * What the Libraries section may offer. A platform admin previewing as a
 * customer admin sees exactly what a delegated admin would: no platform-only
 * actions, and indexing actions only when the previewed matrix grants it.
 */
export function resolveLibraryAdminPermissions({
  isPlatformAdmin,
  previewEnabled,
  userCapabilities,
  previewModes,
}: {
  isPlatformAdmin: boolean
  previewEnabled: boolean
  userCapabilities: Record<string, string> | undefined
  previewModes: Record<string, CapabilityMode> | undefined
}): LibraryAdminPermissions {
  if (isPlatformAdmin && !previewEnabled) {
    return { canManagePlatformOnly: true, canManageIndexing: true }
  }
  const modes = isPlatformAdmin ? previewModes : userCapabilities
  return { canManagePlatformOnly: false, canManageIndexing: modes?.indexing === "manage" }
}
